<template>
  <div>
    <Navigation />
    <div class="login-section ptb-100">
      <div class="container">
        <div class="login-form">
          <div class="login-title">
            <h3>Register to Join Us!</h3>
            <p>Fill Membership Form.</p>
          </div>
          <iframe :src="src" width="540" height="812" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navigation from "./navBar/Navigation";
import Footer from "./Footer";

export default {
  name: "Register",
  props:["src"],
  components: {
    Navigation,
    Footer
  }
};
</script>

<style scoped></style>